/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Injectable } from '@angular/core';
import { SearchExploreRequest } from '@app/app/shared/models/page/page.model';
import { LinkableCardSummary, LinkablePlaylistSummary, SearchPlaylist } from '../../../shared/models';
import { GlobalSearch, GlobalSearchPlaylist } from '../../../shared/models/global-search/global-search.model';
import { Page } from '../../../shared/models/page';
import { ObservableResult } from '../../../shared/store';
import { createDummySearchPlaylist } from '../../mock-utils';
import { GlobalSearchDataService } from './global-search-data.service';

/* eslint-disable max-len */
@Injectable()
export class MockGlobalSearchDataService implements GlobalSearchDataService {
  searchContent(page: number, size: number, term: string): ObservableResult<Page<GlobalSearch>> {
    return ObservableResult.ofSuccess({
      currentPageNumber: 0,
      pageSize: 1,
      totalNumberOfElement: 1,
      content: [],
    });
  }

  searchExplore(page: number, size: number, request: SearchExploreRequest): ObservableResult<Page<GlobalSearchPlaylist>> {
    return ObservableResult.ofSuccess();
  }

  searchExploreDynamicSection(
    sectionName: string,
    page: number,
    size: number,
    request: SearchExploreRequest,
  ): ObservableResult<Page<GlobalSearchPlaylist>> {
    return ObservableResult.ofSuccess();
  }

  searchPlaylists(page: number, term: string, type?: string): ObservableResult<Page<SearchPlaylist>> {
    return ObservableResult.ofSuccess({
      currentPageNumber: 0,
      pageSize: 1,
      totalNumberOfElement: 1,
      content: [createDummySearchPlaylist('id1')],
    });
  }

  searchLinkablePlaylistsV3(
    page: number,
    term: string,
    exclusions?: string[],
    pageSize: number = 10,
    types?: string[],
  ): ObservableResult<Page<LinkablePlaylistSummary>> {
    return ObservableResult.ofSuccess({
      currentPageNumber: 0,
      pageSize: pageSize,
      totalNumberOfElement: 1,
      content: [{ header: term, id: 'linkable-id1' }],
    });
  }

  searchLinkableCards(
    page: number,
    term: string,
    exclusions?: string[],
    pageSize: number = 10,
    cardType?: string,
  ): ObservableResult<Page<LinkableCardSummary>> {
    return ObservableResult.ofSuccess({
      currentPageNumber: 0,
      pageSize: pageSize,
      totalNumberOfElement: 1,
      content: [{ header: term, id: 'linkable-card-id1' }],
    });
  }

  searchLinkableCardsV3(
    page: number,
    term: string,
    exclusions?: string[],
    pageSize: number = 10,
    cardType?: string,
  ): ObservableResult<Page<LinkableCardSummary>> {
    return ObservableResult.ofSuccess({
      currentPageNumber: 0,
      pageSize: pageSize,
      totalNumberOfElement: 1,
      content: [{ header: term, id: 'linkable-card-id1' }],
    });
  }

  searchLinkablePlaylists(
    page: number,
    term: string,
    excludedId?: string,
    pageSize: number = 10,
    type?: string,
  ): ObservableResult<Page<LinkablePlaylistSummary>> {
    return ObservableResult.ofSuccess({
      currentPageNumber: 0,
      pageSize: pageSize,
      totalNumberOfElement: 1,
      content: [{ header: term, id: excludedId + '0' }],
    });
  }
}
